<template>
    <div class="">
        <div class="block-content">
            <div class="row">
                <div class="col-md-6 col-xl-3">
                    <a class="block block-rounded block-link-shadow bg-xwork-lighter" href="javascript:void(0)">
                        <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                            <div>
                                <i class="fa fa-2x fa-arrow-alt-circle-up text-primary-lighter"></i>
                            </div>
                            <div class="ml-3 text-right">
                                <p class="text-white font-size-h3 font-w300 mb-0">
                                    + 45%
                                </p>
                                <p class="text-white-75 mb-0">
                                    Earnings
                                </p>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-6 col-xl-3">
                    <a class="block block-rounded block-link-shadow bg-xwork-lighter" href="javascript:void(0)">
                        <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                            <div>
                                <i class="far fa-2x fa-user text-success-light"></i>
                            </div>
                            <div class="ml-3 text-right">
                                <p class="text-white font-size-h3 font-w300 mb-0">
                                    +98%
                                </p>
                                <p class="text-white-75 mb-0">
                                    Users
                                </p>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-6 col-xl-3">
                    <a class="block block-rounded block-link-shadow bg-xwork-lighter" href="javascript:void(0)">
                        <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                            <div class="mr-3">
                                <p class="text-white font-size-h3 font-w300 mb-0">
                                    450
                                </p>
                                <p class="text-white-75 mb-0">
                                    Sales
                                </p>
                            </div>
                            <div>
                                <i class="fa fa-2x fa-chart-line text-danger-light"></i>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-6 col-xl-3">
                    <a class="block block-rounded block-link-shadow bg-xwork-lighter" href="javascript:void(0)">
                        <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                            <div class="mr-3">
                                <p class="text-white font-size-h3 font-w300 mb-0">
                                    63
                                </p>
                                <p class="text-white-75 mb-0">
                                    Projects
                                </p>
                            </div>
                            <div>
                                <i class="fa fa-2x fa-boxes text-warning-light"></i>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <div class="block block-bordered">
            <div class="block-header block-header-default">
                <div class="block-title">
                    Payment Transactions
                </div>

                <!--<download-csv-->
                <!--:data="transactions_mpesa"-->
                <!--class="btn btn-default"-->
                <!--name="filename.csv">-->
                <!--Download Data-->
                <!--<img src="download_icon.png">-->
                <!--</download-csv>-->
            </div>

            <div class="block-content">
                <el-tabs v-model="activeName" @tab-click="handleClick">

                    <el-tab-pane label="M-PESA" name="zero">
                        <div class="block-content">
                            <v-server-table theme="bootstrap4" :columns="columns_mpesa" :options="options_mpesa">
                                <span slot="transaction_status"></span>
                            </v-server-table>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="Mobile Paybill" name="first">
                        <div class="block-content">
                            <v-server-table theme="bootstrap4" :columns="columns_mobile_money" :options="options_mobile_money">
                                <span slot="transaction_status"></span>
                            </v-server-table>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="Pesalink" name="second">
                        <div class="block-content">
                            <v-server-table theme="bootstrap4" :columns="columns_pesalink" :options="options_pesalink">
                                <span slot="transaction_status"></span>
                            </v-server-table>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="EFT" name="third">
                        <div class="block-content">
                            <v-server-table theme="bootstrap4" :columns="columns_eft" :options="options_eft">
                                <span slot="transaction_status"></span>
                            </v-server-table>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="SWIFT" name="fourth">
                        <div class="block-content">
                            <v-server-table theme="bootstrap4" :columns="columns_swift" :options="options_swift">
                                <span slot="transaction_status"></span>
                            </v-server-table>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="RTGS" name="fifth">
                        <div class="block-content">
                            <v-server-table theme="bootstrap4" :columns="columns_rtgs" :options="options_rtgs">
                                <span slot="transaction_status"></span>
                            </v-server-table>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="Equity Bank" name="sixth">
                        <div class="block-content">
                            <v-server-table theme="bootstrap4" :columns="columns_equity_bank"
                                            :options="options_equity_bank">
                                <span slot="transaction_status"></span>
                            </v-server-table>
                        </div>
                    </el-tab-pane>

                    <!--<el-tab-pane label="Task" name="sixth">Task</el-tab-pane>-->
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PGTransactions",
        data() {
            return {
                activeName: 'first',
                transactions_mpesa: {},
                transactions_mobile_money: {},
                transactions_pesalink: {},
                transactions_eft: {},
                transactions_swift: {},
                transactions_rtgs: {},
                transactions_equity_bank: {},
                columns_mpesa: [
                    'request_id',
                    'msisdn',
                    'amount',
                    'mpesa_transaction_id',
                    'success',
                    'operator',
                    'created_at'
                ], columns_mobile_money: [
                    'transaction_id',
                    'source_name',
                    'amount',
                    'reference',
                    'response',
                    'description',
                    'created_at'
                ], columns_pesalink: [
                    'transaction_id',
                    'source_name',
                    'amount',
                    'reference',
                    'response',
                    'description',
                    'created_at'
                ],
                columns_eft: [
                    'transaction_id',
                    'source_name',
                    'amount',
                    'reference',
                    'response',
                    'description',
                    'created_at'
                ],
                columns_swift: [
                    'transaction_id',
                    'source_name',
                    'amount',
                    'reference',
                    'response',
                    'description',
                    'created_at'
                ],
                columns_rtgs: [
                    'transaction_id',
                    'source_name',
                    'amount',
                    'reference',
                    'response',
                    'description',
                    'created_at'
                ],
                columns_equity_bank: [
                    'transaction_id',
                    'source_name',
                    'amount',
                    'reference',
                    'response',
                    'description',
                    'created_at'
                ],
                options_mpesa: {
                    requestFunction: function (data) {
                        return axios.get(`projects/${this.$route.params.project}/pg/mpesa/transactions`, {
                            params: data
                        }).catch(function (e) {
                            this.dispatch('error', e);
                        }.bind(this));
                    }
                },
                options_mobile_money: {
                    requestFunction: function (data) {
                        return axios.get(`projects/${this.$route.params.project}/pg/mobile-money/transactions`, {
                            params: data
                        }).catch(function (e) {
                            this.dispatch('error', e);
                        }.bind(this));
                    }
                },
                options_pesalink: {
                    requestFunction: function (data) {
                        return axios.get(`projects/${this.$route.params.project}/pg/pesalink-bank/transactions`, {
                            params: data
                        }).catch(function (e) {
                            this.dispatch('error', e);
                        }.bind(this));
                    }
                },
                options_eft: {
                    requestFunction: function (data) {
                        return axios.get(`projects/${this.$route.params.project}/pg/eft/transactions`, {
                            params: data
                        }).catch(function (e) {
                            this.dispatch('error', e);
                        }.bind(this));
                    }
                },
                options_swift: {
                    requestFunction: function (data) {
                        return axios.get(`projects/${this.$route.params.project}/pg/swift/transactions`, {
                            params: data
                        }).catch(function (e) {
                            this.dispatch('error', e);
                        }.bind(this));
                    }
                },
                options_rtgs: {
                    requestFunction: function (data) {
                        return axios.get(`projects/${this.$route.params.project}/pg/rtgs/transactions`, {
                            params: data
                        }).catch(function (e) {
                            this.dispatch('error', e);
                        }.bind(this));
                    }
                },
                options_equity_bank: {
                    requestFunction: function (data) {
                        return axios.get(`projects/${this.$route.params.project}/pg/equitybank/transactions`, {
                            params: data
                        }).catch(function (e) {
                            this.dispatch('error', e);
                        }.bind(this));
                    }
                }
            }
        },
        mounted() {
            this.fetchTransactions()
        },
        methods: {
            /**
             *
             */
            fetchTransactions() {

            },
            handleClick(tab, event) {
                console.log(tab, event);
            }
        }
    }
</script>

<style scoped>
    .VueTables__child-row-toggler {
        width: 16px;
        height: 16px;
        line-height: 16px;
        display: block;
        margin: auto;
        text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
        content: "+";
    }

    .VueTables__child-row-toggler--open::before {
        content: "-";
    }
</style>
